import React from 'react';
import {Link, NavLink} from 'react-router-dom';
import {useModal} from '@ui/Modal';
import {FeedbackModal} from '../components/FeedbackModal';
import styles from './layouts.module.scss';

export const Footer = () => {
    const dialogRef = useModal(() => (
        <FeedbackModal onClose={() => dialogRef.close()} />
    ));

    const handleFeedbackClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.preventDefault();
        dialogRef.open({});
    };
    return (
        <div className={styles.footer}>
            <Link to='/docx/oferta.pdf' rel='noopener noreferrer' target='_blank' className={styles.footer__link}>
                Условия использования
            </Link>
            <Link to='/docx/policy.pdf' rel='noopener noreferrer' target='_blank' className={styles.footer__link}>
                Политика конфиденциальности
            </Link>
            <Link
                to="#"
                className={styles.footer__link}
                onClick={handleFeedbackClick}
            >
                Обратная связь
            </Link>
        </div>
    );
};
